/**
 * Mega Menu JavaScript
 */

function toggleMegaMenu() {
  const dropdown = document.getElementById('megaMenuDropdown');
  const button = document.getElementById('produktyDropdown');
  const megaMenu = document.getElementById('mega-menu');
  const icon = button ? button.querySelector('.mega-menu-dropdown-icon') : null;

  if (dropdown.classList.contains('show')) {
    dropdown.classList.remove('show');
    document.body.style.overflow = '';
    // Remove mobile open class and dropdown open class from mega-menu element
    if (megaMenu) {
      megaMenu.classList.remove('mega-menu-mobile-open');
      megaMenu.classList.remove('mega-menu-dropdown-open');
    }
    if (button) button.setAttribute('aria-expanded', 'false');
    if (icon) icon.style.transform = 'rotate(0deg)';
  } else {
    dropdown.classList.add('show');
    // Add dropdown open class to mega-menu element for logo z-index styling
    if (megaMenu) megaMenu.classList.add('mega-menu-dropdown-open');
    // Only prevent body scroll on desktop, allow on mobile for mega menu scrolling
    if (window.innerWidth > 768) {
      document.body.style.overflow = 'hidden';
    } else {
      // Add mobile open class to mega-menu element for mobile-specific styling
      if (megaMenu) megaMenu.classList.add('mega-menu-mobile-open');
    }
    if (button) button.setAttribute('aria-expanded', 'true');
    if (icon) icon.style.transform = 'rotate(180deg)';
  }
}

function closeMegaMenu() {
  const dropdown = document.getElementById('megaMenuDropdown');
  const button = document.getElementById('produktyDropdown');
  const megaMenu = document.getElementById('mega-menu');
  const icon = button ? button.querySelector('.mega-menu-dropdown-icon') : null;

  dropdown.classList.remove('show');
  document.body.style.overflow = '';
  // Remove mobile open class and dropdown open class from mega-menu element
  if (megaMenu) {
    megaMenu.classList.remove('mega-menu-mobile-open');
    megaMenu.classList.remove('mega-menu-dropdown-open');
  }
  if (button) button.setAttribute('aria-expanded', 'false');
  if (icon) icon.style.transform = 'rotate(0deg)';
}

// Sprawdz Gdzie Popup functionality for mega menu
function initMegaMenuSprawdzPopup() {
  const button = document.getElementById('megaMenuSprawdzBtn');
  const popup = document.getElementById('megaMenuSprawdzPopup');

  if (!button || !popup) return;

  const overlay = popup.querySelector('.popup-overlay');
  const closeBtn = popup.querySelector('.popup-close');
  const uspWrapper = popup.querySelector('#usp-pdslist-wrapper-mega');
  let uspDataLoaded = false;

  // Function to load USP Center data
  function loadUSPData() {
    if (uspDataLoaded || !uspWrapper) return;

    try {
      // Clear any existing content
      uspWrapper.innerHTML = '';

      // Add loading indicator
      uspWrapper.innerHTML =
        '<div class="usp-loading"><p>Ładowanie apteki...</p></div>';

      // Create the list structure that the USP script expects
      const uspList = document.createElement('ul');
      uspWrapper.appendChild(uspList);

      // Load USP data
      const unixTime = Date.now();
      const jsonUrl = 'https://pds.usp.center/ibuprom.json?' + unixTime;

      fetch(jsonUrl)
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(data => {
          // Remove loading indicator
          const loadingDiv = uspWrapper.querySelector('.usp-loading');
          if (loadingDiv) loadingDiv.remove();

          // Shuffle the array (like original script)
          for (let i = data.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [data[i], data[j]] = [data[j], data[i]];
          }

          // Populate the list
          data.forEach(item => {
            const li = document.createElement('li');
            li.innerHTML =
              '<a href="' +
              item.URL +
              '" target="_blank" rel="noopener" onclick="' +
              item.onclick +
              '" data-pdsid="' +
              item.pdsid +
              '" class="usp-pdslist-a"><span class="usp-pdslist-name">' +
              item.name +
              '</span><span class="usp-pdslist-checkstring">Sprawdź dostępność</span></a>';
            uspList.appendChild(li);
          });

          uspDataLoaded = true;
        })
        .catch(error => {
          console.warn('USP Center data loading failed:', error);
          uspWrapper.innerHTML =
            '<div class="usp-error"><p>Nie udało się załadować listy aptek. <a href="https://ktomalek.pl/" target="_blank" rel="noopener">Sprawdź dostępność tutaj</a></p></div>';
        });
    } catch (error) {
      console.error('USP initialization error:', error);
      uspWrapper.innerHTML =
        '<div class="usp-error"><p>Wystąpił błąd podczas ładowania.</p></div>';
    }
  }

  // Open popup
  button.addEventListener('click', function (e) {
    e.preventDefault();
    popup.style.display = 'flex';
    // Small delay to allow display change to take effect
    setTimeout(() => {
      popup.classList.add('show');
      // Load USP data when popup opens
      loadUSPData();
    }, 10);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Focus management
    closeBtn.focus();
  });

  // Close popup functions
  function closePopup() {
    popup.classList.remove('show');
    setTimeout(() => {
      popup.style.display = 'none';
    }, 300);

    // Restore body scroll
    document.body.style.overflow = '';

    // Return focus to button
    button.focus();
  }

  // Close on overlay click
  overlay.addEventListener('click', closePopup);

  // Close on close button click
  closeBtn.addEventListener('click', closePopup);

  // Close on Escape key (but only if mega menu dropdown is not open)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('show')) {
      const megaDropdown = document.getElementById('megaMenuDropdown');
      if (!megaDropdown || !megaDropdown.classList.contains('show')) {
        closePopup();
      }
    }
  });

  // Trap focus within popup when open
  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      const focusableElements = popup.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });
}

// Scroll detection functionality
function initScrollDetection() {
  const megaMenu = document.getElementById('mega-menu');

  if (!megaMenu) return;

  let isScrolled = false;
  let ticking = false;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldBeScrolled = scrollTop > 100;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;

      if (isScrolled) {
        megaMenu.classList.add('mega-menu-scrolled');
      } else {
        megaMenu.classList.remove('mega-menu-scrolled');
      }
    }

    ticking = false;
  }

  function requestScrollUpdate() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  // Add scroll event listener with throttling
  window.addEventListener('scroll', requestScrollUpdate, { passive: true });

  // Check initial scroll position
  handleScroll();
}

// Wait for DOM to load, then add event listeners
document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('produktyDropdown');
  const dropdown = document.getElementById('megaMenuDropdown');
  const closeBtn = document.getElementById('megaMenuCloseBtn');

  // Add click listener to the button
  if (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      toggleMegaMenu();
    });
  }

  // Add click listener to the close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMegaMenu();
    });
  }

  // Close menu when clicking outside
  document.addEventListener('click', function (event) {
    if (
      dropdown &&
      button &&
      !dropdown.contains(event.target) &&
      !button.contains(event.target)
    ) {
      closeMegaMenu();
    }
  });

  // Close menu with Escape key (but not if sprawdz popup is open)
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const sprawdzPopup = document.getElementById('megaMenuSprawdzPopup');
      if (!sprawdzPopup || !sprawdzPopup.classList.contains('show')) {
        closeMegaMenu();
      }
    }
  });

  // Initialize scroll detection
  initScrollDetection();

  // Initialize sprawdz popup functionality
  initMegaMenuSprawdzPopup();
});
